import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCollaborationPointerLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCollaborationPointerLeft"><Path d="M9.4502 22.1123L12.7822 12.7812L22.1123 9.4502L3.45215 3.45215L9.4502 22.1123Z" fill="currentColor"/><Path d="M15.1836 14.5518L14.709 14.709L14.5518 15.1836L12.5518 21.1836L14.4482 21.8164L16.291 16.29L21.8164 14.4482L21.1836 12.5518L15.1836 14.5518Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCollaborationPointerLeft;
